import * as api from "../../../../api";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { ALERT, AUTH } from "../../../../constants/actionTypes";

import { createQuote } from "../../../../utils/createQuote";
import { validateEmail, validatePassword } from "../../../../utils/validation";

import {
  ArrowDropDown,
  KeyboardBackspace,
  Search,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";

import Timezones from "../../../../data/timezone";

import "../Signup.css";

const Signup = ({ uploadQuote, setShowSignup, order, auth }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validEmail, setValidEmail] = useState(true);
  const [validPassword, setValidPassword] = useState(true);
  const [passwordError, setPasswordError] = useState("Okay");
  const [showPassword, setShowPassword] = useState(false);
  const [regexTimezones, setRegexTimezones] = useState(".");
  const [accountDetails, setAccountDetails] = useState({
    email: uploadQuote ? uploadQuote.email : "",
    password: "",
    timezone: "(WAT) West African Time",
    name: "",
    phone: "",
    organization: "",
    companyName: "",
    address: "",
    postal_code: "",
    city: "",
    VAT: "",
    role: "basic",
  });
  const disableOrder =
    order &&
    (accountDetails.name.trim() === "" ||
      accountDetails.email.trim() === "" ||
      accountDetails.password.trim() === "" ||
      agreed === false ||
      !uploadQuote.files ||
      loading ||
      !validateEmail(accountDetails.email) ||
      validatePassword(accountDetails.password) !== "okay");

  const disableAuth =
    accountDetails.name.trim() === "" ||
    accountDetails.email.trim() === "" ||
    accountDetails.password.trim() === "" ||
    agreed === false ||
    loading ||
    !validateEmail(accountDetails.email) ||
    validatePassword(accountDetails.password) !== "okay";

  const newRegexTimezones = new RegExp(regexTimezones, "i");

  const timezones = Timezones.filter((timezone) =>
    newRegexTimezones.test(timezone)
  );

  const handleAccountChange = (e) => {
    if (e.target.name === "email") {
      setValidEmail(validateEmail(e.target.value));
    }
    if (e.target.name === "password") {
      let message = validatePassword(e.target.value);
      if (message === "okay") {
        setValidPassword(true);
        setPasswordError("Okay");
      } else {
        setValidPassword(false);
        setPasswordError(message);
      }
    }
    setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value });
  };

  const handleTimezoneSelect = (e) => {
    setAccountDetails({ ...accountDetails, timezone: e.target.textContent });
    document.querySelector(".signup__details").removeAttribute("open");
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await api.signUp(accountDetails);
      dispatch({ type: AUTH, data });

      await api.counter({ total_clients: 1 });
      await api.sendAuthEmail({
        email: accountDetails.email,
        name: accountDetails.name,
      });

      if (auth) handleToDashboard(data);
      if (order) createQuote(uploadQuote, setLoading, dispatch, history);

      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message:
            "Confirm your emaill address with the link sent to your mail, to enjoy our full services",
          duration: 7000,
          display: true,
        },
      });
    } catch (error) {
      setLoading(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  const handleToDashboard = (user) => {
    if (user.role === "basic") history.push("/projects/index");
    if (user.role === "translator") history.push("/translator/profile");
    if (user.role === "admin") history.push("/admin/index");
  };

  const handlePasswordVisibility = () =>
    setShowPassword((showPassword) => !showPassword);

  const optionStyle = {
    backgroundColor: "#ff5e15",
    color: "white",
  };

  return (
    <>
      <form className="signupForm mb-40 w-100">
        <h3 className="mt-20 mb-40">Create an account</h3>
        <div className="d-flex justify-between mb-40">
          <label className="w-45 position-relative">
            <p className="font-heavy mb-10 ml-5">
              Emaill address<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="email"
              name="email"
              value={accountDetails.email}
              onChange={handleAccountChange}
              required
            />
            {!validEmail && <div className="error-input">Invalid Email</div>}
          </label>
          <label className="w-45 position-relative">
            <p className="font-heavy mb-10 ml-5">
              Password<sup className="font-bold ml-5">*</sup>
            </p>
            <div className="border-1 rounded d-flex justify-between align-center">
              <input
                style={{ border: "none" }}
                className="input"
                type={showPassword ? "text" : "password"}
                name="password"
                value={accountDetails.password}
                autoComplete="true"
                onChange={handleAccountChange}
                required
              />
              {accountDetails.password.length > 0 && (
                <div
                  style={{ height: "50px" }}
                  className="d-flex align-center h-100 bg-transparent pointer px-10 rounded-tr rounded-br"
                  onClick={handlePasswordVisibility}
                >
                  {!showPassword ? (
                    <VisibilityOutlined className="icon-light-grey" />
                  ) : (
                    <VisibilityOffOutlined className="icon-light-grey" />
                  )}
                </div>
              )}
            </div>
            {!validPassword && (
              <div className="error-input">{passwordError}</div>
            )}
          </label>
        </div>
        <div className="mb-40">
          <p className="font-heavy mb-10 ml-5">Timezone</p>
          <details className="signup__details position-relative">
            <summary className="input d-flex align-center justify-between list-none">
              <span>{accountDetails.timezone}</span>
              <ArrowDropDown />
            </summary>
            <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
              <div className="d-flex align-center border-bottom-1">
                <input
                  className="border-0 outline-0 w-100 font-normal p-20"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => setRegexTimezones(e.target.value)}
                />
                <Search className="icon-light-grey m-20" />
              </div>
              <div className="d-flex flex-column overflow-auto">
                {timezones.length < 1 ? (
                  <span className="p-20">Not Found</span>
                ) : (
                  timezones.map((timezone) => (
                    <span
                      className="signup__drop__time p-20 border-bottom-1 text-capitalise pointer"
                      key={timezone}
                      style={
                        timezone === accountDetails.timezone ? optionStyle : {}
                      }
                      onClick={handleTimezoneSelect}
                    >
                      {timezone}
                    </span>
                  ))
                )}
              </div>
            </div>
          </details>
        </div>
        <h3 className="mb-40">Billing Information</h3>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Full Name<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="text"
              name="name"
              value={accountDetails.fullName}
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Phone Number</p>
            <input
              className="input"
              type="tel"
              name="phone"
              value={accountDetails.phone}
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <div className="w-45">
            <p className="font-heavy mb-10 ml-5">Who are You?</p>
            <div className="signupForm__org input d-flex align-center justify-between">
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="company"
                  name="organization"
                  onChange={handleAccountChange}
                />
                Company
              </label>
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="individual"
                  name="organization"
                  onChange={handleAccountChange}
                />
                Individual
              </label>
            </div>
          </div>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Company Name</p>
            <input
              className="input"
              type="text"
              name="companyName"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Address (line 1)</p>
            <input
              className="input"
              type="text"
              name="address"
              value={accountDetails.address}
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Postal Code</p>
            <input
              className="input"
              type="text"
              name="postal_code"
              value={accountDetails.postal_code}
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">City</p>
            <input
              className="input"
              type="text"
              name="city"
              value={accountDetails.city}
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">VAT Number</p>
            <input
              className="input"
              type="number"
              name="VAT"
              value={accountDetails.VAT}
              onChange={handleAccountChange}
            />
          </label>
        </div>
      </form>
      <div className="d-flex flex-column align-center justify-center">
        <div>
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className="signup__terms pl-10 font-heavy">
            I agree to OneConverse Translations'{" "}
            <Link to="/terms-and-condition">Terms & Conditions</Link> and{" "}
            <Link to="/terms-and-condition">Privacy Policy</Link>
          </span>
        </div>
        {auth && (
          <Link to="/auth/signin" className="auth__link py-10">
            Already have an account? Sign in
          </Link>
        )}
      </div>
      {order && (
        <div className="d-flex justify-between pt-40 p b-20">
          <button
            className="button bg-transparent d-flex align-center"
            onClick={() => setShowSignup(false)}
          >
            <KeyboardBackspace className="mr-10" /> Back
          </button>
          <button
            className="d-flex align-center justify-center border-1 outline-0 py-10 rounded pointer"
            style={{ opacity: disableOrder ? "0.6" : "" }}
            disabled={disableOrder}
            onClick={handleContinue}
          >
            Submit Order
            {loading && <div className="spin-white ml-10"></div>}
          </button>
        </div>
      )}
      {auth && (
        <button
          className="signup__btn d-flex align-center justify-center border-0 outline-0 font-normal font-bold w-100 p-10 my-20"
          style={{ opacity: disableAuth ? "0.6" : "" }}
          disabled={disableAuth}
          onClick={handleContinue}
        >
          Create Account
          {loading && <div className="spin-white ml-10"></div>}
        </button>
      )}
    </>
  );
};

export default Signup;
